// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_landing_landing_module_ts":"e8df0395cf7b58fb","node_modules_aws-sdk_credential-provider-cognito-identity_dist-es_loadCognitoIdentity_js":"a716c096afe48d1a"}[chunkId] + ".js";
};